<template>
  <div class="aontractManage-dialog "
       v-if="drawer">
    <el-dialog :title="'合同管理'"
               :visible.sync="drawerShow"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="700px"
               @close="colseDrawer"
               class="colleague-dialog">
      <el-form ref="form"
               :model="form"
               :inline="true"
               :rules="rules"
               label-width="110px"
               size="mini">
        <el-form-item label="合同开始"
                      prop="startTime">
          <el-date-picker v-model="form.startTime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同结束"
                      prop="endTime">
          <el-date-picker v-model="form.endTime"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同编号"
                      prop="contractNo">
          <el-input v-model="form.contractNo"></el-input>
        </el-form-item>

        <el-form-item label="合同结束前提醒">
          <el-switch v-model="form.isHint"></el-switch>
        </el-form-item>
        <el-row>
          <el-form-item label="合同主要条款"
                        class="form-item-block">
            <el-input type="textarea"
                      :rows="6"
                      resize="none"
                      placeholder="请输入简介"
                      v-model="form.contractClause">
            </el-input>
          </el-form-item>
        </el-row>
        <el-form-item label="附件"
                      class="form-item-block">
          <el-upload action=""
                     :file-list="filePath"
                     :on-remove="removeFile"
                     :http-request="uploadFile"
                     :on-preview="preview"
                     ref="upload"
                     style="width: 242px"
                     :disabled="onlyReadyflag">
            <div style="margin-top: -5px">
              <el-button size="small"
                         :disabled="onlyReadyflag"
                         type="primary">点击上传</el-button>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="colseDrawer()
            ">取 消</el-button>
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="onSubmit('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    drawerShow: Boolean,
    operation: String,
    customerInfo: Object,
  },
  data () {
    return {
      submitLoading: false,
      drawer: false,
      filePath: [],
      form: {
      },
      rules: {
        contractNo: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
        ],
        startTime: [{ required: true, message: "请选择合同开始时间", trigger: "blur" }],
        endTime: [{ required: true, message: "请选择合同结束时间", trigger: "blur" }],
        isStop: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["blur", "change"],
          },
        ],
      },
      companyId: "",
      onlyReadyflag: false,
      drawer: false,
    };
  },

  methods: {
    validateForm (formName) {
      let isValidate = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          isValidate = true;
        } else {
          isValidate = false;
        }
      });
      return isValidate;
    },
    onSubmit () {
      if (!this.validateForm("form")) {
        this.$message.warning("填写信息有误，请检查表单");
        return;
      }
      let sendData = {
        id: this.companyId,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        contractAccessory: this.filePath && this.filePath.length > 0 ? this.filePath[0].url : '',
        contractNo: this.form.contractNo,
        contractClause: this.form.contractClause,
        isHint: this.form.isHint,
      };
      this.$api.customer.EditCustomerContract(sendData).then((res) => {
        if (res.error === false) {
          this.$message.success("保存成功");
          this.$emit("refreshData");
        } else {

        }
        this.submitLoading = false;
        this.colseDrawer();
      });
    },

    uploadFile (fileObj) {
      console.log(fileObj);
      const formData = new FormData();
      formData.append("file", fileObj.file);
      this.$api.upload.uploadFile(formData).then((res) => {
        if (res.code == 0) {
          this.filePath = [];
          this.filePath.push({
            name: fileObj.file.name,
            url: res.data[0],
            uid: fileObj.file.uid,
            urlPath: res.data[0],
          });
        } else {
          this.removeFile(fileObj);
        }

      });
    },
    removeFile (value) {
      this.filePath.forEach((item, i) => {
        console.log(value.uid, item.uid);
        if (item.uid == value.uid) {
          this.filePath.splice(i, 1);
        }
      });
    },
    preview (value) {
      window.open(value.url, "_blank");

    },
    colseDrawer () {
      this.$emit("colseDrawer");
    },
    fillFormData (customerInfo) {
      this.filePath = [];
      this.$set(this.form, "startTime", customerInfo.startTime);
      this.$set(this.form, "endTime", customerInfo.endTime);
      this.$set(this.form, "contractNo", customerInfo.contractNo);
      this.$set(this.form, "contractAccessory", customerInfo.contractAccessory);
      this.$set(this.form, "contractClause", customerInfo.contractClause);
      this.$set(this.form, "isHint", customerInfo.isHint);
      if (customerInfo.contractAccessory) {
        this.filePath.push({
          name: '合同附件',
          url: customerInfo.contractAccessory,
          urlPath: customerInfo.contractAccessory,
        });
      }

    },

    getUserInfo () {
      const memberId = JSON.parse(localStorage.getItem("Authorization"))
        ? JSON.parse(localStorage.getItem("Authorization")).memberId
        : "";
      if (!memberId) return;
      this.$api.user.getUserInfo(memberId).then((res) => {
        if (res.code === 0) {
          this.currentUserInfo = res.data;
        }
      });
    },
  },
  watch: {
    drawerShow (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs["form"].clearValidate();
        });
      }

      this.companyId = this.customerInfo.id;
      this.drawer = val;
      this.fillFormData(this.customerInfo);
    },
  },
};
</script>

<style lang="less">
.aontractManage-dialog {
  .form-item-block {
    width: 100% !important;
    .el-form-item__content {
      width: 82% !important;
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-form-item {
    width: 48%;
    .el-form-item__content {
      width: 56%;
    }
    .el-select {
      width: 100%;
    }
  }
}
</style>
